// General
import { routerPath as challenges } from 'pages/general/Challenges/utils';
import { routerPath as notValidatedClasses } from 'pages/general/NotValidatedClasses/utils';
import { routerPath as licensedProviders } from 'pages/general/LicensedProviders/utils';
import { routerPath as facility } from 'pages/general/Facility/utils';
import { routerPath as registeredUsers } from 'pages/general/RegisteredUsers/utils';
import { routerPath as corporate } from 'pages/general/Corporate/utils';
import { routerPath as personalTrainers } from 'pages/general/PersonalTrainers/utils';
import { routerPath as oakleyEvents } from 'pages/general/OakleyEvents/utils';

// Shop
import { routerPath as brands } from 'pages/shop/Brands/utils';
import { routerPath as colors } from 'pages/shop/Colors/utils';
import { routerPath as vendors } from 'pages/shop/Vendors/utils';
import { routerPath as ordersYFC } from 'pages/shop/OrdersYFC/utils';
import { routerPath as ordersVendor } from 'pages/shop/OrdersVendor/utils';
import { routerPath as voucherOrder } from 'pages/shop/VoucherOrder/utils';
import { routerPath as allProducts } from 'pages/shop/AllProducts/utils';

// Settings
import { routerPath as users } from 'pages/settings/Users/utils';
import { routerPath as bonuses } from 'pages/settings/Bonuses/utils';
import { routerPath as globalSettings } from 'pages/settings/GlobalSettings/utils';
import { routerPath as regions } from 'pages/settings/Regions/utils';
import { routerPath as influencers } from 'pages/settings/Influencers/utils';
import { routerPath as oakleyBenefits } from 'pages/settings/OakleyBenefits/utils';
import { routerPath as progressLevels } from 'pages/settings/ProgressLevels/utils';

// Reports
import { routerPath as challengesReport } from 'pages/reports/ChallengesReports/utils';
import { routerPath as userReferralReport } from 'pages/reports/UserReferralReports/utils';
import { routerPath as userAccessReport } from 'pages/reports/UserAccessReports/utils';
import { routerPath as classCreditsReport } from 'pages/reports/ClassCreditsReports/utils';
import { routerPath as influencersReports } from 'pages/reports/InfluencersReports/utils';
import { routerPath as userSubscriptions } from 'pages/reports/UserSubscriptions/utils';
import { routerPath as userOakleySubscriptions } from 'pages/reports/UserOakleySubscriptions/utils';
import { routerPath as gymAttendanceReports } from 'pages/reports/GymAttendanceReports/utils';
import { routerPath as gymAttendanceWithRedLine } from 'pages/reports/GymAttendanceReportsWithRedLine/utils';
import { routerPath as usersAttendanceGymReportFacilityAdmin } from 'pages/reports/UsersAttendanceReportsGymFacilityAdmin/utils';
import { routerPath as usersAttendanceReportStudioFacilityAdmin } from 'pages/reports/UsersAttendanceReportsStudioFacilityAdmin/utils';
import { routerPath as studioAttendancePerClassReport } from 'pages/reports/StudioAttendancePerClassReportsFacilityAdmin/utils';
import { routerPath as userAccessReportGymFacilityAdmin } from 'pages/reports/UsersAccessReportsGymFacilityAdmin/utils';
import { routerPath as itemizedSalesReport } from 'pages/reports/ItemizedSalesReport/utils';
import { routerPath as retailSalesReport } from 'pages/reports/RetailSalesReport/utils';
import { routerPath as vendorSalesReport } from 'pages/reports/VendorSalesReport/utils';
import { routerPath as personalTrainersCommissionReport } from 'pages/reports/PersonalTrainersCommissionReport/utils';
import { routerPath as dubai3030Report } from 'pages/reports/Dubai3030Report/utils';
import { routerPath as challengesActivityReport } from 'pages/reports/ChallengesActivityReport/utils';
import { routerPath as personalTrainersSalesReport } from 'pages/reports/PersonalTrainersSalesReport/utils';

const ROOTS_DASHBOARD = '/';
const ROOTS_AUTH = '/auth';

export const PATH_RESET = {
  root: '/reset',
};

export const PATH_AUTH = {
  root: ROOTS_AUTH,
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  // General
  facility,
  licensedProviders,
  notValidatedClasses,
  challenges,
  registeredUsers,
  personalTrainers,
  oakleyEvents,

  // Settings
  oakleyBenefits,
  influencers,
  regions,
  globalSettings,
  bonuses,
  users,
  corporate,
  progressLevels,

  // Shop
  brands,
  colors,
  vendors,
  ordersYFC,
  ordersVendor,
  voucherOrder,
  allProducts,

  // Reports
  userAccessReportGymFacilityAdmin,
  studioAttendancePerClassReport,
  usersAttendanceReportStudioFacilityAdmin,
  usersAttendanceGymReportFacilityAdmin,
  gymAttendanceWithRedLine,
  gymAttendanceReports,
  userSubscriptions,
  userOakleySubscriptions,
  influencersReports,
  classCreditsReport,
  userAccessReport,
  userReferralReport,
  challengesReport,
  itemizedSalesReport,
  retailSalesReport,
  vendorSalesReport,
  personalTrainersCommissionReport,
  dubai3030Report,
  challengesActivityReport,
  personalTrainersSalesReport,
};
